import styles from './Auth.module.scss'
import { AuthForm } from './AuthForm/AuthForm'
import { AuthNavBar } from './AuthNavbar/AuthNavBar'
import { useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import mobileFrame from 'assets/mobile_frame.png'
import login from 'assets/login.png'
import loginMobile from 'assets/login_mobile.png'
import drizzle from 'assets/drizzle.svg'
import classnames from 'classnames'
import { useIsMobile } from 'hooks/useIsMobile'
import { Icon } from 'components/Icon/Icon'
import { previousStep } from 'redux/rootSlice/rootSlice'


export function Auth() {
    const { signupStep } = useAppSelector((state) => state.root)
    const dispatch = useAppDispatch()
    const { isMobile, screenWidth } = useIsMobile()

    const location = useLocation()
    const pathname = String(location.pathname).split('/')[1]

    const isLogin = pathname !== 'login'
    const showDepositContent = signupStep >= 3 && isLogin

    const logoClassName = classnames({
        [styles['logo']]: true,
        [styles['logo_pink']]: showDepositContent
    })

    function handleBack() {
        dispatch(previousStep())
    }


    if (screenWidth < 1300) {
        const showMobileContent = signupStep >= 4 && isLogin
        const showNavBar = signupStep === 1 && signupStep < 4
        const showBack = signupStep > 1 && signupStep < 4 && isLogin

        return (
            <div className={styles['mobile']}>
                {showNavBar && (
                    <AuthNavBar pathname={pathname} />
                )}
                {showBack && (
                    <div
                        className={styles['back']}
                        onClick={handleBack}>
                        <Icon name='back' />
                    </div>
                )}
                {!showMobileContent && (
                    <div className={styles['mobile__logo']}>
                        <img
                            src={drizzle}
                            className={styles['mobile__img']}
                            alt='drizzle login'
                        />
                    </div>
                )}
                <div className={styles['mobile__content']}>
                    <AuthForm pathname={pathname} />
                </div>
            </div >
        )
    }

    return (
        <div className={styles['wrapper']}>
            <AuthNavBar pathname={pathname} />
            <div className={styles['content']}>
                <AuthForm pathname={pathname} />
            </div>
            <div className={logoClassName}>
                {!showDepositContent ? (
                    <img
                        src={login}
                        className={styles['img']}
                        alt='drizzle login'
                    />
                ) : (
                    <div className={styles['mobileImg']}>
                        <img
                            src={mobileFrame}
                            alt='drizzle mobile'
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

